import { mapGetters, mapActions } from 'vuex'
import RegulationTypeModule, { MODULE_NAME } from './index'

const RegulationTypeMixin = {
  namespaced: RegulationTypeModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(RegulationTypeModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(RegulationTypeModule.actions)) }
}

export default RegulationTypeMixin



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/mixin.js